export default __webpack_public_path__ + "static/media/elizabeth.e488f67e.png";